import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery"; // Import useMediaQuery
import Box from "@mui/material/Box";
//import { Chip } from '@mui/material';
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Home from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router-dom";
import MenuEntry from "../menu/MenuEntry";
import MenuSearch from "../menu/MenuSearch";
import MenuUtilities from "../menu/MenuUtilities";
import MenuAdmin from "../menu/MenuAdmin";
import "../css/color.css";
import TokenService from "../service/TokenService";
import MenuReports from "../menu/MenuReports";
import { useAuthentication } from "../customHook/useAuthentecation";
import logo from "../photo/logo.jpg";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(.5),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "white !important",
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function PersistentDrawerLeft() {
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const role = tokenServiceDetails?.role;
  //const fullname = tokenServiceDetails?.FullName;
  const consignee = tokenServiceDetails?.consignee || "";
  const urights = tokenServiceDetails?.userrights;

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { clearAuth } = useAuthentication();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the viewport is mobile

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    clearAuth();
    navigate("/");
  };

  const handleNavigation = (path) => {
    navigate(path);
    handleDrawerClose();
  };

  // React.useLayoutEffect(() => {
  //   document.body.style.background =
  //     "linear-gradient(to right, #000000, #000fff)";
  // }, []);

 React.useLayoutEffect(() => {
    document.body.style.background =
      "#d7def3ff";
  }, []);


  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="white"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon style={{ color: "red" }} />
          </IconButton>
          {/* {!isMobile && ( */}
           
            <div>
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: "60%",
                  height: "20%",
                  border: "1px solid white",
                   // Add padding inside the image (between image and border)
                }}
              />
            </div>
          {/* )} */}
          {/* {!isMobile && ( // Only display this on non-mobile screens
            <Typography variant="h4" sx={{ display: "flex", alignItems: "center" }}>
              Non-Stock Management System
            </Typography>
          )} */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", width: "60%" }}
          >
            <span style={{ color: "blue" }}>
              {"Role => "}
              {role} &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <span style={{ color: "red" }}>
              {"User => "}
              {uname}
            </span>
            {consignee && consignee.length < 8 && (
              <span style={{ color: "navy" }}>
                &nbsp;&nbsp;&nbsp;&nbsp;{"Consignee Code => "}
                {consignee}
              </span>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {/* Drawer and other components remain the same */}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon style={{ color: "red" }} />
            ) : (
              <ChevronRightIcon style={{ color: "red" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <ListItem disablePadding onClick={() => handleNavigation("/dashboard")}>
          <ListItemButton>
            <ListItemIcon>
              <Home style={{ color: "brown" }} />
            </ListItemIcon>
            <ListItemText sx={{ color: "brown" }}> Dashboard </ListItemText>
          </ListItemButton>
        </ListItem>
        <Divider />
        <MenuEntry handleNavigation={handleNavigation} />
        <Divider />

        {(urights === 1 || urights === 2) && (
  <>
  {/* <Chip label="Admin" color="primary" variant="outlined" style={{ marginTop: 8 }} /> */}
    <MenuAdmin handleNavigation={handleNavigation} />
    <Divider />
    
  </>
)}

    <MenuReports handleNavigation={handleNavigation} />
        <Divider />
        <MenuSearch handleNavigation={handleNavigation} />
        <Divider />
        <MenuUtilities handleNavigation={handleNavigation} />
        <Divider />
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon style={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText sx={{ color: "red" }}> Logout </ListItemText>
          </ListItemButton>
        </ListItem>
        <Divider />
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        <Outlet />
      </Main>
    </Box>
  );
}
